<template>
  <div class="w-100">
    Follow-up added to {{ $lodash.get(activity, "detail.job.follow_up_to") }} for Job Status
    {{ $lodash.get(activity, "detail.job.status") }}
  </div>
</template>

<script type="text/babel">
import BaseComponent from "./BaseComponent.vue";

export default {
  extends: BaseComponent,
};
</script>
